"use strict";

{
	const html = document.querySelector("html");
	if (html instanceof HTMLElement) {
		// Accordion items
		document.querySelectorAll(".accordion-item").forEach((item) => {
			item.querySelector(".accordion-button")?.addEventListener("click", (ev) => {
				item.classList.toggle("active");
			});
			html.addEventListener("click", (ev) => {
				const target = ev?.target;
				if (target instanceof HTMLElement && !item.contains(target)) {
					item.classList.remove("active");
				}
			});
		});
	}
}
